angular.module('core')
  .service('infiniteScroll', ['$analytics', '$state', 'dblLocation', function($analytics, $state, dblLocation) {
      var self = this;

      self.handlePageResponse = function($scope, data) {
          $scope.links = data.links;
          $scope.endOfPage = !(data.links && data.links.next_page);
          $state.current.data.next_page = $scope.endOfPage ? null : data.links.next_page;
          $scope.busy = false;
      };

      self.init = function($scope, onPaging) {
          var pageTrack = function() {
              var urlOrigin = dblLocation.getOrigin();
              var pageUrl = dblLocation.addUrlParameter(urlOrigin, 'page', $scope.page);

              $analytics.pageTrack(pageUrl);
          };

          var handlePagingEvent = function() {
              if (!$scope.busy && !$scope.endOfPage) {
                  $scope.busy = true;
                  $scope.page++;
                  pageTrack();
                  onPaging($scope.links);
              }
          };
          // page only used for GA
          $scope.page = 1;
          $scope.links = null;
          $scope.busy = false;
          $state.current.data.next_page = undefined;

          $scope.$on('scrolledToBottom', handlePagingEvent);
          $scope.$on('mobileScrollBottom', handlePagingEvent);
      };

      self.getNextPage = function () {
          // TODO: not clear why next page is stored on $state
          return $state.current.data.next_page;
      };

      return self;
  }]);
